interface FormValidationApi {
  validate: (opts?: { silent?: boolean }) => Promise<unknown>
}

/** Re-sincroniza errores de UForm tras mutar `state` por código (login, prefill, etc.). */
export async function syncFormValidation(form?: FormValidationApi | null) {
  if (!form) return
  await nextTick()
  await form.validate({ silent: true })
}